import { ICON_X_BLACK } from '../../modules/svg/svg'

import { useMemo } from 'react'
import { s_app_download } from '../../modules/i18n/strings/auto/wording'
import useTranslation from '../../modules/i18n/useTranslation'
import { getTeensAppDownLinkByDevice } from '../../modules/utils'

interface GeneralMobileAppDownPopupProps {
  onClose: () => void
  onClickFooter?: () => void
  popupLocation:
    | APP_DOWN_POPUP_LOCATION.LANDING_HOME
    | APP_DOWN_POPUP_LOCATION.PORTAL_WELCOME
    | APP_DOWN_POPUP_LOCATION.PORTAL_PAYMENT_COMPLETE
  popupData?: object
}

interface ContentsMobileAppDownPopupProps {
  onClose: () => void
  onClickFooter?: () => void
  popupLocation:
    | APP_DOWN_POPUP_LOCATION.LANDING_MATERIAL
    | APP_DOWN_POPUP_LOCATION.PORTAL_MATERIAL_AD
    | APP_DOWN_POPUP_LOCATION.TEENS_LANDING_MATERIAL
  popupData: {
    contentsId: string | string[]
  }
}

type MobileAppDownPopupProps = GeneralMobileAppDownPopupProps | ContentsMobileAppDownPopupProps

/**
 * 앱 메시지 다운로드 유도 위치
 * - 어느 페이지에서 해당 컴포넌트가 렌더가 되는지 분별용 enum
 */
export enum APP_DOWN_POPUP_LOCATION {
  TEENS_LANDING_MATERIAL,
  LANDING_MATERIAL,
  LANDING_HOME,
  PORTAL_WELCOME,
  PORTAL_PAYMENT_COMPLETE,
  PORTAL_MATERIAL_AD,
}

const MobileAppDownPopup = ({ onClose, onClickFooter = null, popupLocation, popupData }: MobileAppDownPopupProps) => {
  const { t, locale, isLocaleKO } = useTranslation()

  const appDownDynamicLink: string = useMemo(() => {
    switch (popupLocation) {
      case APP_DOWN_POPUP_LOCATION.TEENS_LANDING_MATERIAL: {
        return getTeensAppDownLinkByDevice()
      }
      case APP_DOWN_POPUP_LOCATION.LANDING_MATERIAL: {
        return `https://ringle.page.link/?link=https://ringleplus.com/${locale}/student/landing/contents/material/${popupData.contentsId}&apn=com.ringle&ibi=org.reactjs.native.example.Ringle&isi=1189876556&efr=1`
      }

      case APP_DOWN_POPUP_LOCATION.LANDING_HOME: {
        return 'https://ringle.page.link/Rxsr'
      }
      case APP_DOWN_POPUP_LOCATION.PORTAL_WELCOME: {
        return 'https://ringle.page.link/FPdL'
      }
      case APP_DOWN_POPUP_LOCATION.PORTAL_PAYMENT_COMPLETE: {
        return 'https://ringle.page.link/eGEA'
      }
      case APP_DOWN_POPUP_LOCATION.PORTAL_MATERIAL_AD: {
        return `https://ringle.page.link/?link=https://ringleplus.com/${locale}/student/landing/contents/material/${popupData.contentsId}&apn=com.ringle&ibi=org.reactjs.native.example.Ringle&isi=1189876556&efr=1`
      }
    }
  }, [locale, popupLocation, popupData])

  const popupLabelObj = useMemo(() => {
    switch (popupLocation) {
      case APP_DOWN_POPUP_LOCATION.TEENS_LANDING_MATERIAL:
      case APP_DOWN_POPUP_LOCATION.LANDING_MATERIAL:
      case APP_DOWN_POPUP_LOCATION.LANDING_HOME:
      case APP_DOWN_POPUP_LOCATION.PORTAL_WELCOME:
      case APP_DOWN_POPUP_LOCATION.PORTAL_PAYMENT_COMPLETE: {
        return {
          label: t(s_app_download.label),
          button: t(s_app_download.button),
          footer: t(s_app_download.footer),
        }
      }
      case APP_DOWN_POPUP_LOCATION.PORTAL_MATERIAL_AD: {
        return {
          label: t(s_app_download.title),
          button: t(s_app_download.btn_1),
          footer: t(s_app_download.btn_2),
        }
      }
    }
  }, [])

  return (
    <div
      style={{ top: '0', left: '0', backgroundColor: 'rgba(0, 0, 0, 0.7)', zIndex: 9999999 }}
      className="fixed flex h-full w-full flex-shrink-0 items-end justify-center p-[20px]"
    >
      <div className="relative flex min-h-[265px] w-full flex-col items-center justify-end rounded-[20px] bg-white pb-16">
        <div className="absolute top-24 right-24" onClick={onClose}>
          <img src={ICON_X_BLACK} />
        </div>

        <div className="flex items-center justify-center">
          <img src="/assets/img/logo/logo_primary_circle.svg" className="mr-[20px] h-[50px] w-[50px] rounded-lg" />
          <img src="/assets/img/logo/logo_text_primary.svg" className="mt-[6px] h-[30px]" />
        </div>

        <p
          className={`text-sTitle mt-12 break-words px-[22px] text-center font-normal ${
            isLocaleKO && popupLocation !== APP_DOWN_POPUP_LOCATION.PORTAL_MATERIAL_AD && 'max-w-[250px]'
          }`}
        >
          {popupLabelObj.label}
        </p>

        <div className="mt-24 flex w-full items-center justify-center text-center">
          <button
            className="w-full max-w-[250px] rounded-[30px] bg-purple-500 py-[13px] text-center text-white"
            onClick={() => {
              window.open(appDownDynamicLink, '_blank', 'noopener,noreferrer')
            }}
          >
            {popupLabelObj.button}
          </button>
        </div>

        <div
          className="text-14 mt-11 text-center font-normal  leading-[20px] text-gray-700 underline underline-offset-2"
          onClick={onClickFooter ? onClickFooter : onClose}
        >
          {popupLabelObj.footer}
        </div>
      </div>
    </div>
  )
}

export default MobileAppDownPopup
